import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=6a664470&"
import script from "./academic.vue?vue&type=script&lang=js&"
export * from "./academic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports